import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Loader";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Loader label="Loading your neighbourhood…" />;
  if (!user) return <Navigate to="/auth/sign-in" state={{ from: location }} replace />;
  if (!user.onboarding_completed && location.pathname !== "/onboarding")
    return <Navigate to="/onboarding" replace />;
  return children;
};
